module.exports = __webpack_public_path__ + "static/img/f0163938785a574d85ac6fcba5ae0606.png";


//////////////////
// WEBPACK FOOTER
// ./src/public-resource/components/reward/img/reward-img.png
// module id = 25Ts
// module chunks = 0